import { StyledVizPaper, StyledSubmoduleHeader } from '../styledComponents';
import Typography from 'common/Typography';
import AttributeLineageGraph from 'features/forceGraphs/components/AttributeLineageGraph';
import { FunctionComponent } from 'react';

const LineageModule: FunctionComponent = () => {
	return (
		<StyledVizPaper>
			<StyledSubmoduleHeader>
				<Typography>Lineage</Typography>
			</StyledSubmoduleHeader>
			<AttributeLineageGraph />
		</StyledVizPaper>
	);
};

export default LineageModule;
